import { getToken } from "../../services/storageService";
import { readCachedSessionUser } from "./authSession.storage";
import {
  APPLICATION_NOT_ASSIGNED_PATH,
  getAuthCallbackPath,
} from "./authSession.service";
import { hasAppLoggedOutFlag, redirectToKeycloakLogin } from "../logout";
import { isSsoPrefetchRequest } from "./ssoPrefetch";

export function isAppSessionActive(): boolean {
  return (
    !hasAppLoggedOutFlag() &&
    Boolean(getToken()) &&
    Boolean(readCachedSessionUser())
  );
}

export function isPublicAuthPath(pathname: string): boolean {
  const authCallbackPath = getAuthCallbackPath();
  return [
    "/login",
    "/forgot-password",
    "/reset-password",
    authCallbackPath,
    APPLICATION_NOT_ASSIGNED_PATH,
  ].some((path) => pathname === path || pathname.endsWith(path));
}

export function enforceLoggedOutWall(): void {
  if (typeof window === "undefined") return;
  if (isSsoPrefetchRequest()) return;
  if (!hasAppLoggedOutFlag()) return;
  if (isPublicAuthPath(window.location.pathname)) return;
  void redirectToKeycloakLogin();
}
